import { useCallback } from "react";

import { captureEvent } from "@/lib/analyticsQueue";
import { ANALYTICS_EVENTS } from "@shared/schemas/analytics";
import { WHATSAPP_COMMUNITY_URL } from "@/config/constants";
import type { CommunityCtaSource } from "./constants";

/**
 * Single source of truth for the community-group link + click analytics. Every
 * placement (success page, first-generation modal, profile card, footer link)
 * uses this so the URL and the `community_cta_click` event are defined once.
 */
export function useCommunityCta() {
  const getCommunityHref = useCallback(() => WHATSAPP_COMMUNITY_URL, []);

  const openCommunity = useCallback((source: CommunityCtaSource) => {
    captureEvent(ANALYTICS_EVENTS.COMMUNITY_CTA_CLICK, { source });
  }, []);

  return { getCommunityHref, openCommunity };
}
